import {z} from 'zod';

import {promptSchema} from './PromptSchema';

/**
 * Schema for GET /list response
 */
export const getListPromptsResponseSchema = z.object({
  prompts: z.array(promptSchema),
  total: z.number().int().nonnegative(),
  limit: z.number().int().positive(),
  offset: z.number().int().nonnegative(),
});

export type GetListPromptsResponse = z.infer<typeof getListPromptsResponseSchema>;
